// ── Currency formatter ────────────────────────────────────────
export const fmtCurrency = (amount, currency = "INR") =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount || 0);

// ── Date formatter ────────────────────────────────────────────
export const fmtDate = (dateStr) => {
  if (!dateStr) return "—";
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(dateStr));
};

// ── Transaction type config ───────────────────────────────────
export const TYPE_CONFIG = {
  earning:    { label: "Earning",    color: "success",  muiColor: "#10b981", bgAlpha: "rgba(16,185,129,0.12)"  },
  withdraw:   { label: "Withdraw",   color: "primary",  muiColor: "#3b82f6", bgAlpha: "rgba(59,130,246,0.12)"  },
  refund:     { label: "Refund",     color: "error",    muiColor: "#ef4444", bgAlpha: "rgba(239,68,68,0.12)"   },
  hold:       { label: "Hold",       color: "warning",  muiColor: "#f59e0b", bgAlpha: "rgba(245,158,11,0.12)"  },
  release:    { label: "Release",    color: "secondary",muiColor: "#8b5cf6", bgAlpha: "rgba(139,92,246,0.12)"  },
  adjustment: { label: "Adjust",     color: "default",  muiColor: "#64748b", bgAlpha: "rgba(100,116,139,0.12)" },
};

// ── Transaction status config ─────────────────────────────────
export const STATUS_CONFIG = {
  pending:    { label: "Pending",    color: "warning"  },
  approved:   { label: "Approved",   color: "info"     },
  processing: { label: "Processing", color: "primary"  },
  completed:  { label: "Completed",  color: "success"  },
  failed:     { label: "Failed",     color: "error"    },
  rejected:   { label: "Rejected",   color: "error"    },
  cancelled:   { label: "Cancelled",   color: "error"    },
};

// ── Wallet card definitions ───────────────────────────────────
export const WALLET_CARDS = [
  {
    key:     "totalEarning",
    label:   "Total Earning",
    desc:    "Cumulative lifetime earnings",
    icon:    "TrendingUp",
    accent:  "#10b981",
    shadow:  "rgba(16,185,129,0.2)",
  },
  {
    key:     "availableBalance",
    label:   "Available Balance",
    desc:    "Ready to withdraw now",
    icon:    "AccountBalanceWallet",
    accent:  "#3b82f6",
    shadow:  "rgba(59,130,246,0.2)",
  },
  {
    key:     "pendingBalance",
    label:   "Pending Balance",
    desc:    "Order placed, not yet delivered",
    icon:    "HourglassEmpty",
    accent:  "#f59e0b",
    shadow:  "rgba(245,158,11,0.2)",
  },
  {
    key:     "holdBalance",
    label:   "Hold Balance",
    desc:    "Delivered — 24h return window",
    icon:    "Lock",
    accent:  "#8b5cf6",
    shadow:  "rgba(139,92,246,0.2)",
  },
  {
    key:     "totalWithdrawn",
    label:   "Total Withdrawn",
    desc:    "Lifetime withdrawal amount",
    icon:    "CallMade",
    accent:  "#ec4899",
    shadow:  "rgba(236,72,153,0.2)",
  },
];

// ── UPI ID validator ──────────────────────────────────────────
export const isValidUPI = (upiId) => /^[\w.\-]+@[\w]+$/.test(upiId);

// ── IFSC validator ────────────────────────────────────────────
export const isValidIFSC = (ifsc) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc);

// ── Account number validator ──────────────────────────────────
export const isValidAccountNo = (acc) => /^\d{9,18}$/.test(acc);
